<template>
  <v-container>
    <v-row>
      <v-col v-for="note in releaseNote" :key="note" cols="12">
        <v-card>
          <v-subheader class="text-h5">{{ note.date }}</v-subheader>

          <v-list two-line>
            <template v-for="(n, index) in note.content">
              <v-list-item :key="n">
                <v-list-item-content>
                  <v-list-item-title class="my-2">{{
                    n.title
                  }}</v-list-item-title>

                  <v-list-item-subtitle>
                    {{ n.body }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="index !== note.content.length - 1"
                :key="`divider-${index}`"
              ></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import releaseNoteJSON from "@/assets/release.json";

export default {
  computed: {
    releaseNote() {
      return releaseNoteJSON.data;
    },
  },
};
</script>
